import { render, staticRenderFns } from "./JointLogin.vue?vue&type=template&id=0ca769f4&scoped=true&"
import script from "./JointLogin.vue?vue&type=script&lang=js&"
export * from "./JointLogin.vue?vue&type=script&lang=js&"
import style0 from "./JointLogin.vue?vue&type=style&index=0&id=0ca769f4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ca769f4",
  null
  
)

export default component.exports